/*
 * @Description:
 * @Author: dingyajun
 * @Date: 2022-07-21 11:20:46
 * @LastEditTime: 2023-12-25 10:35:02
 * @LastEditors: zhangjiangpo
 * @Reference:
 */
export default [
  {
    title: '学员姓名',
    dataIndex: 'userName',
    scopedSlots: { customRender: 'userName' }
  },
  {
    title: '手机号',
    dataIndex: 'phoneNumber',
    scopedSlots: { customRender: 'phoneNumber' }
  },
  {
    title: '绑定家长端',
    dataIndex: 'studentQr',
    scopedSlots: { customRender: 'studentQr' }
  },
  {
    title: '年级',
    dataIndex: 'gradeName',
    scopedSlots: { customRender: 'gradeName' }
  },
  {
    title: '添加来源',
    dataIndex: 'origin',
    scopedSlots: { customRender: 'origin' }
  },
  {
    title: '金币数',
    dataIndex: 'coinsNum',
    scopedSlots: { customRender: 'coinsNum' }
  },
  {
    title: '金币增减',
    dataIndex: 'interactedNum',
    scopedSlots: { customRender: 'interactedNum' },
    width: 300
  }
  // {
  //   title: '操作',
  //   dataIndex: 'detail',
  //   scopedSlots: { customRender: 'detail' }
  // }
]